<template>
  <HomeCommonLayout>
    <template #content>
      <RenewalContent>
        <SkillpathContent />
      </RenewalContent>
    </template>
  </HomeCommonLayout>
</template>

<script setup lang="ts">
import { useHead } from "#imports";
import SkillpathContent from "~~/codepresso-renewal/content/SkillpathContent.vue";
import { useSeoMeta } from "~/composables/useSeoMeta";

const { getCanonical, getHreflangLinks } = useSeoMeta();

useHead({
  title: "SkillPath — 8개 분야 IT·SW 트랙과 STEP 학습 경로 | 코드프레소",
  meta: [
    { name: "description", content: "8개 분야 IT·SW 코스를 STEP 단위 트랙으로 잇는 온라인 자기주도 학습 서비스. 임직원은 자기 수준에서 시작해 필요한 깊이까지 올라갑니다." },
    { name: "title", content: "SkillPath — 8개 분야 IT·SW 트랙과 STEP 학습 경로 | 코드프레소" },
    { name: "robots", content: "index,follow" },
    { property: "og:title", content: "SkillPath — 8개 분야 IT·SW 트랙과 STEP 학습 경로 | 코드프레소" },
    { property: "og:description", content: "8개 분야 IT·SW 코스를 STEP 단위 트랙으로 잇는 온라인 자기주도 학습 서비스. 임직원은 자기 수준에서 시작해 필요한 깊이까지 올라갑니다." },
  ],
  link: [...getHreflangLinks.value, { rel: "canonical", href: getCanonical.value }],
});
</script>

<style>
/* renewal 의 임베드 빌드 산출물(codepresso-renewal/embed). 모든 셀렉터가
   `.renewal-root` 를 요구하므로 헤더·푸터로 새지 않는다.
   로딩 순서는 renewal 원본과 같게 main → 페이지 전용 → mobile 로 둔다. */
@import "../../codepresso-renewal/embed/css/main.css";
@import "../../codepresso-renewal/embed/css/pages/skillpath.css";
@import "../../codepresso-renewal/embed/css/mobile.css";
</style>
